import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import PropTypes from "prop-types";

const ImportHTMLEmailModal = ({ 
  show, 
  onHide, 
  onSubmit 
}) => {
  const [htmlInput, setHtmlInput] = useState('');
  const [showLoader, setShowLoader] = useState(false);

  const handleInputChange = (e) => {
    const input = e.target.value;
    setHtmlInput(input);
  };

  const handleSubmit = () => {
      setShowLoader(true);
      onSubmit(htmlInput, ()=>{
        setShowLoader(false);
        setHtmlInput('');
        onHide();
      });
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="lg" 
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Import HTML Email Template
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Control
              as="textarea"
              rows={10}
              value={htmlInput}
              onChange={handleInputChange}
              placeholder="Paste your HTML Email here"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      {
        showLoader &&
        <Modal.Footer>
          <img src="../images/loader.gif" width={30}/>
        </Modal.Footer>
      }
      {
        !showLoader &&
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={()=>{handleSubmit()}}
          >
            Submit
          </Button>
        </Modal.Footer>
      }
    </Modal>
  );
};

ImportHTMLEmailModal.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onSubmit: PropTypes.func
}

export default ImportHTMLEmailModal;